import { gql } from "apollo-boost";

export const analysisAppRating = gql`
  query analysisAppRating($filter: AnalysisFilter!) {
    analysisAppRating(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const analysisUserRating = gql`
  query analysisUserRating($filter: AnalysisFilter!) {
    analysisUserRating(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const analysisAppUser = gql`
  query analysisAppUser($filter: AnalysisFilter!) {
    analysisAppUser(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const analysisAppUserPeer = gql`
  query analysisAppUserPeer($filter: AnalysisFilter!) {
    analysisAppUserPeer(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const analysisPostUsageTrends = gql`
  query analysisPostUsageTrends($filter: AnalysisFilter!) {
    analysisPostUsageTrends(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const analysisPsUsageTrends = gql`
  query analysisPsUsageTrends($filter: AnalysisFilter!) {
    analysisPsUsageTrends(filter: $filter) {
      series {
        code
        title
        data {
          key
          value
        }
      }
    }
  }
`;

export const dashboardGql = {
  analysisAppRating,
  analysisUserRating,
  analysisAppUser,
  analysisAppUserPeer,
  analysisPostUsageTrends,
  analysisPsUsageTrends,
};
